'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./product/contactPdp'));
    processInclude(require('./components/socialList'));
    processInclude(require('./search/search'));
    // processInclude(require('./product/quickView'));
    processInclude(require('./listingPage/listingPage'));
    // processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/wishlistHeart'));
});

var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var observer = new MutationObserver(function(mutations, observer) {
    for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.className.toString().includes('helpButtonEnabled')) {
            var stikyHeight = $('.cc-sticky-add-to-cart').height();
            if (window.isMobile) {
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    bottom: stikyHeight + 24,
                    right: '16px'
                });
                if ($('.cc-requestsize-only-mobile').is(':visible')) {
                    $('.helpButton, #embeddedMessagingConversationButton').css('display', 'none');
                }
            } else if (window.isTablet && $('.cc-sticky-add-to-cart').hasClass('cc-open')) {
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    bottom: stikyHeight + 46,
                    right: '30px'
                });
            } else if (window.isDesktop && $('.cc-sticky-add-to-cart').hasClass('cc-open')) {
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    bottom: stikyHeight + 46,
                    right: '30px'
                });
            }
        }
    }

    for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.className.toString().includes('helpButtonEnabled')) {
            var stikyHeight = $('.sticky-bar-mobile').height();
            if ($('.js-sticky-look-container').length > 0) {
                stikyHeight = $('js-sticky-add-to-cart-look').height();
            }
            if (window.isMobile) {
                
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    bottom: stikyHeight,
                    right: '16px'
                });
                if (!$('#mobileSortingWindow').hasClass('d-none')) {
                    $('.helpButton, #embeddedMessagingConversationButton').css({
                        display: 'none',
                        visibility: 'hidden'
                    });
                }
                if (!$('#mobileFilterWindow').hasClass('d-none')) {
                    $('.helpButton, #embeddedMessagingConversationButton').css({
                        display: 'none',
                        visibility: 'hidden'
                    });
                }
            }
        }
    }
});
observer.observe(document, {
    subtree: true,
    attributes: true
});
